import { apiClient } from '@/api/client';
import { RatingWire, ratingsListResponseSchema } from '../schemas/rating';

/**
 * Domain-oriented API module for rating operations
 * Provides typed functions for fetching menu item ratings from the Gateway API
 */

/**
 * Get all menu item ratings
 *
 * @returns List of all available ratings
 *
 * @example
 * ```typescript
 * const ratings = await getRatings();
 * // Returns: [
 * //   { id: 1, key: 'must_try', label: 'Must Try' },
 * //   { id: 2, key: 'try_it', label: 'Try It' },
 * //   { id: 3, key: 'its_ok', label: "It's OK" },
 * //   { id: 4, key: 'skip_it', label: 'Skip It' }
 * // ]
 * ```
 */
export async function getRatings(): Promise<RatingWire[]> {
  const endpoint = '/api/menu-item-ratings';
  const wireData = await apiClient.get<RatingWire[]>(endpoint);

  // Validate response with zod schema
  return ratingsListResponseSchema.parse(wireData);
}
